import { Expose, plainToInstance } from "class-transformer";
import camelcaseKeys from "camelcase-keys";

export class DestinationResolverModel {
  @Expose()
  public id?: number;

  @Expose()
  public companyName?: string;

  @Expose()
  public branchName?: string;

  @Expose()
  public displayName?: string;

  public static toClass(data: object) {
    //@ts-ignore
    return plainToInstance(DestinationResolverModel, camelcaseKeys(data, { deep: true }), { excludeExtraneousValues: true });
  }

  public static toArrayOfClass(data: object[]) {
    //@ts-ignore
    return plainToInstance(DestinationResolverModel, camelcaseKeys(data, { deep: true }) as DestinationResolverModel[], { excludeExtraneousValues: true });
  }
}
